if (!customElements.get('product-sticky-media')) {
  customElements.define(
    'product-sticky-media',
    class ProductStickyMedia extends HTMLElement {
      connectedCallback() {
        if (!this.classList.contains('product__media-wrapper--sticky')) return;

        this.product = this.closest('.product');
        if (!this.product) return;

        this.desktop = window.matchMedia('(min-width: 750px)');
        this.currentOffset = 0;
        this.frame = null;
        this.topOffset = 30;

        this.handleScroll = () => this.scheduleUpdate();
        this.handleResize = () => this.scheduleMeasure();

        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleResize, { passive: true });
        this.desktop.addEventListener('change', this.handleResize);

        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(this);
        this.resizeObserver.observe(this.product);

        this.querySelectorAll('img').forEach((image) => {
          if (!image.complete) image.addEventListener('load', this.handleResize, { once: true });
        });

        this.measure();
      }

      disconnectedCallback() {
        if (!this.handleScroll) return;

        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
        this.desktop.removeEventListener('change', this.handleResize);
        this.resizeObserver.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      scheduleUpdate() {
        if (this.frame) return;

        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }

      scheduleMeasure() {
        if (this.frame) cancelAnimationFrame(this.frame);

        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.measure();
        });
      }

      measure() {
        this.style.transform = '';
        this.currentOffset = 0;

        const mediaRect = this.getBoundingClientRect();
        const productRect = this.product.getBoundingClientRect();

        this.naturalTop = window.scrollY + mediaRect.top;
        this.maxOffset = Math.max(0, window.scrollY + productRect.bottom - this.naturalTop - mediaRect.height);
        this.update();
      }

      update() {
        if (!this.desktop.matches || this.maxOffset <= 0) {
          if (this.currentOffset !== 0) {
            this.style.transform = '';
            this.currentOffset = 0;
          }
          return;
        }

        const nextOffset = Math.min(this.maxOffset, Math.max(0, window.scrollY + this.topOffset - this.naturalTop));
        if (Math.abs(nextOffset - this.currentOffset) < 0.5) return;

        this.style.transform = `translate3d(0, ${nextOffset}px, 0)`;
        this.currentOffset = nextOffset;
      }
    }
  );
}
